module.exports = __webpack_public_path__ + "img/parqe-icon.ad4d174d.svg";